<script>
import {mapState} from "vuex";

export default {
    name: "youtubeOverview",
     data () {
        return {
            filterDays: 0,
            performanceData: [
                {
                    label: 'Views',
                    name: 'views',
                    value: '',
                    trend: ''
                },
                {
                    label: 'Likes',
                    name: 'likes',
                    value: '',
                    trend: ''
                },
                {
                    label: 'Comments',
                    name: 'comments',
                    value: '',
                    trend: ''
                },
                {
                    label: 'Dislikes',
                    name: 'dislikes',
                    value: '',
                    trend: ''
                },
                {
                    label: 'Subscribers gained',
                    name: 'subscribers_gained',
                    value: '',
                    trend: ''
                },
                {
                    label: 'Minutes watched',
                    name: 'estimated_minutes_watched',
                    value: '',
                    trend: ''
                }
            ],
            averagePerformanceData: [
                {
                    label: 'Average engagements',
                    name: 'engagements',
                    value: '',
                    series: [
                        {
                            name: '',
                            data: []
                        }
                    ]
                },
                {
                    label: 'Average views',
                    name: 'views',
                    value: '',
                    series: [
                        {
                            name: '',
                            data: []
                        }
                    ]
                },
                {
                    label: 'Average subscribers gained',
                    name: 'subscribers_gained',
                    value: '',
                    series: [
                        {
                            data: []
                        }
                    ]
                }
            ],
            chartOptions: {
                chart: {
                    height: 200,
                    toolbar: {
                        show: false
                    },
                    zoom: {
                        enabled: true
                    }
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: "70%"
                    }
                },
                dataLabels: {
                    enabled: false
                },
                xaxis: {
                    type: "datetime",
                    labels: {
                        show: false
                    }
                },
                yaxis: {
                    labels: {
                        show: false,
                        formatter: function(val) {
                            return val.toFixed(0)
                        }
                    }
                },
                colors: ["#01baf1", "#f156e3"],
                legend: {
                    position: "bottom"
                },
                fill: {
                    opacity: 1
                }
            }
        }
     },
    computed: {
        ...mapState('user', {
            youtube: (state) => state.youtube,
            overviewPeriod:  (state) => state.overviewPeriod
        })
    },
    mounted () {
        this.syncDataFromStorage();
    },
    methods: {
        async changeRange (range) {
            let date = new Date();
            date.setDate(date.getDate() - (range-1));
            if (range !== this.filterDays) {
                await this.$store.dispatch('user/getSocialOverview', {sinceDate: date, platform: 'youtube'});
                this.$store.commit('user/SET_SOCIAL_OVERVIEW_PERIOD', {platform: 'youtube', range });
                this.syncDataFromStorage();
            }
        },
        syncDataFromStorage () {
            this.filterDays = this.overviewPeriod.youtube;
            this.performanceData.forEach((data) => {
                data.value = this.youtube.overview.performance[data.name].value;
                if (this.youtube.overview.performance[data.name].trend) {
                    data.trend = this.youtube.overview.performance[data.name].trend;
                }
            });

            this.averagePerformanceData.forEach((data) => {
                data.value = this.youtube.overview.average_performance.average[data.name];
                const newData = Object.entries(this.youtube.overview.average_performance.daily_performance).map(([key, value]) => {
                    return {
                        x: key,
                        y: value[data.name]
                    }
                });
                data.series = [{
                    name: data.label,
                    data: newData
                }];
            });
        }
    }
};
</script>

<template>
    <div>
        <div class="text-muted text-right last-updated">
            <b-dropdown dropleft variant="info" size="sm">
                <template slot="button-content">
                    <i class="mdi mdi-chevron-left"></i>
                    Last {{ filterDays }} days
                </template>
                <b-dropdown-item-button @click="changeRange(7)">Last 7 days</b-dropdown-item-button>
                <b-dropdown-item-button @click="changeRange(30)">Last 30 days</b-dropdown-item-button>
                <b-dropdown-item-button @click="changeRange(90)">Last 90 days</b-dropdown-item-button>
            </b-dropdown>
        </div>
        <div class="tab-section mt-4 pb-0">
            <h5 class="mb-2 mb-xl-4">Performance</h5>
            <div class="row">
                <div class="col-6 col-lg-3 mb-4 mb-xl-5" v-for="data in performanceData" :key="data.label">
                    <div class="row">
                        <div class="col-12 mb-1 font-size-15">
                            {{ data.label }}
                        </div>
                        <div class="col-12 h-100">
                            <h4 class="mb-0">{{ data.value.toLocaleString() }}
                                <span v-if="data.trend">
                                    <span v-if="data.trend > 0" class="badge text-success mr-2"> + {{ data.trend }}% <i class="mdi mdi-arrow-up"></i></span>
                                <span v-else class="badge text-danger mr-2"> {{ data.trend }}% <i class="mdi mdi-arrow-down"></i></span>
                                </span>
                            </h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="tab-section mt-4">
            <h5 class="mb-2 mb-xl-4">Average performance</h5>
            <div class="row">
                <div class="col-12 col-lg-4" v-for="data in averagePerformanceData" :key="data.label" >
                    <apexchart
                            :ref="data.name"
                            class="apex-charts"
                            type="bar"
                            dir="ltr"
                            height="220"
                            :series="data.series"
                            :options="chartOptions"
                    ></apexchart>
                    <p class="text-center">{{ data.label }}</p>
                    <h4 class="mb-0 text-center">{{ data.value.toLocaleString() }}</h4>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>
